<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="256px"
    height="256px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 256 256"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2602869969088">
        <path
          class="fil0"
          d="M128.13 195.09c-22.66,-14.77 -36.03,-35.73 -41.96,-58.66 -9.97,-35.25 -33.42,-55.95 -59.88,-44.86 -26.71,14.72 -32.83,38.69 -19.45,71.4 25.31,48.27 84.88,56.2 121.16,32.34l0.13 -0.22z"
        />
        <path
          class="fil1"
          d="M223.86 89.78c-29.07,-5.86 -46.79,21.62 -51.41,42.86 -7.14,25.12 -19.82,45.84 -43.97,62.67 -0.12,-0.07 -0.23,-0.15 -0.35,-0.22l-0.13 0.22c-36.28,23.86 -95.85,15.93 -121.16,-32.34 26.21,57.08 65.07,94.37 130.32,92.99 53.14,-4.76 87.55,-39.06 111.61,-92.67 15.16,-31.63 6.3,-65.33 -24.91,-73.51z"
        />
        <path
          class="fil0"
          d="M128 195.31c21.59,-14.29 36.07,-36.31 38.9,-71.02 2.27,-27.7 -12.45,-53.95 -38.9,-52.96 -26.45,-0.99 -41.17,25.26 -38.9,52.96 2.83,34.71 17.31,56.73 38.9,71.02z"
        />
        <ellipse class="fil0" cx="128" cy="30.11" rx="30" ry="30.11" />
        <ellipse class="fil1" cx="33.83" cy="47.15" rx="30" ry="30.11" />
        <ellipse class="fil1" cx="222.51" cy="46.87" rx="30" ry="30.11" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
